module.exports = __webpack_public_path__ + "img/worker.0607a0ca.png";